module.exports = __webpack_public_path__ + "img/guide17.d112a00a.jpg";